document.addEventListener('DOMContentLoaded', function () {
  const hotspots = Array.from(document.querySelectorAll('.hotspot'));
  const flyoutPanel = document.createElement('div');
  flyoutPanel.classList.add('flyout-panel');
  document.body.appendChild(flyoutPanel);
  let currentHotspotIndex = -1;
  let lastScrollTop = 0;
  let scrollTimeout;
  let touchStartX = 0;
  let touchStartY = 0;
  let touchEndX = 0;
  let touchEndY = 0;

  function updateFlyoutContent(index) {
    const hotspot = hotspots[index];
    const content = hotspot.querySelector('.hotspot__card').innerHTML;
    flyoutPanel.innerHTML = `
      <div class="flyout-panel__header">
        <button class="flyout-panel__close-btn" aria-label="Close">&times;</button>
        <div class="flyout-panel__counter">${index + 1}/${hotspots.length}</div>
      </div>
      <div class="flyout-panel__navigation">
        <button class="flyout-panel__nav-btn prev" aria-label="Previous feature" ${index === 0 ? 'disabled' : ''}>&lt; PREVIOUS</button>
        <button class="flyout-panel__nav-btn next" aria-label="Next feature" ${index === hotspots.length - 1 ? 'disabled' : ''}>NEXT &gt;</button>
      </div>
      <div class="flyout-panel__content">${content}</div>
    `;
    currentHotspotIndex = index;
    attachEventListeners();
  }

  function attachEventListeners() {
    const closeButton = flyoutPanel.querySelector('.flyout-panel__close-btn');
    const prevButton = flyoutPanel.querySelector('.flyout-panel__nav-btn.prev');
    const nextButton = flyoutPanel.querySelector('.flyout-panel__nav-btn.next');

    closeButton.addEventListener('click', closeFlyoutPanel);

    prevButton.addEventListener('click', function(e) {
      e.stopPropagation();
      navigateHotspot(-1);
    });

    nextButton.addEventListener('click', function(e) {
      e.stopPropagation();
      navigateHotspot(1);
    });
  }

  function navigateHotspot(direction) {
    const newIndex = currentHotspotIndex + direction;
    if (newIndex >= 0 && newIndex < hotspots.length) {
      updateFlyoutContent(newIndex);
    }
  }

  function isMobile() {
    return window.innerWidth <= 768; // Adjust this breakpoint as needed
  }

  function openFlyoutPanel(index) {
    updateFlyoutContent(index);
    flyoutPanel.classList.add('open');
    if (isMobile()) {
      document.body.style.overflow = 'hidden'; // Prevent background scrolling on mobile only
    }
  }

  function closeFlyoutPanel() {
    flyoutPanel.classList.remove('open');
    document.body.style.overflow = ''; // Always re-enable background scrolling
  }

  function handleResize() {
    if (!flyoutPanel.classList.contains('open')) {
      document.body.style.overflow = ''; // Ensure scrolling is enabled when flyout is closed
    } else if (isMobile()) {
      document.body.style.overflow = 'hidden'; // Disable scrolling on mobile when flyout is open
    } else {
      document.body.style.overflow = ''; // Enable scrolling on desktop when flyout is open
    }
  }
  
  // Event delegation for hotspot clicks
  document.addEventListener('click', function(event) {
    const hotspotBtn = event.target.closest('.hotspot__btn');
    if (hotspotBtn) {
      const index = hotspots.findIndex(hotspot => hotspot.contains(hotspotBtn));
      if (index !== -1) {
        openFlyoutPanel(index);
      }
    }
  });

  // Close the flyout panel when clicking outside of it
  document.addEventListener('click', function (event) {
    if (flyoutPanel.classList.contains('open') && !flyoutPanel.contains(event.target) && !hotspots.some(hotspot => hotspot.contains(event.target))) {
      closeFlyoutPanel();
    }
  });

  // Prevent clicks inside the flyout panel from closing it
  flyoutPanel.addEventListener('click', function(event) {
    event.stopPropagation();
  });

  // Scroll detection
  window.addEventListener('scroll', function() {
    if (!flyoutPanel.classList.contains('open')) return;

    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(function() {
      let st = window.pageYOffset || document.documentElement.scrollTop;
      if (Math.abs(lastScrollTop - st) > 50) {
        closeFlyoutPanel();
      }
      lastScrollTop = st <= 0 ? 0 : st;
    }, 100);
  }, false);

  // Touch events for swipe detection
  flyoutPanel.addEventListener('touchstart', function(e) {
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
  }, false);

  flyoutPanel.addEventListener('touchend', function(e) {
    touchEndX = e.changedTouches[0].clientX;
    touchEndY = e.changedTouches[0].clientY;
    handleSwipe();
  }, false);

  function handleSwipe() {
    const swipeThreshold = 50; // minimum distance traveled to be considered swipe
    const horizontalSwipe = touchEndX - touchStartX;
    const verticalSwipe = touchEndY - touchStartY;

    if (Math.abs(horizontalSwipe) > Math.abs(verticalSwipe)) {
      // Horizontal swipe
      if (horizontalSwipe > swipeThreshold) {
        // Right swipe
        closeFlyoutPanel();
      }
    } else {
      // Vertical swipe
      if (Math.abs(verticalSwipe) > swipeThreshold) {
        // Both up and down swipes
        closeFlyoutPanel();
      }
    }
  }

  window.addEventListener('resize', handleResize);
});